import { useMemo } from 'react';
import './telemetry/index.js';
import './google-analytics/index.js';
import './plausible/index.js';
import './pageLoad/index.js';
import { useGoogleAnalytics } from './google-analytics/analytics.js';
import { customElementsObserver } from './pageLoad/elementTiming/CustomElementsObserver.js';
import { _trackEvent } from './plausible/analytics.js';
import { trackMetric } from './telemetry/telemetry.js';

const useGetAnalyticsContext = (props) => {
    const { isSignedIn } = props;
    const googleAnalytics = useGoogleAnalytics({ isSignedIn });
    const context = useMemo(() => ({
        pageLoad: {
            observeCustomElement: customElementsObserver.pushEntry,
        },
        trackEvent: _trackEvent,
        trackGAEvent: googleAnalytics.trackGAEvent,
        removeGACookies: googleAnalytics.removeGACookies,
        trackMetric,
    }), 
    /**
     * We want to make sure that analytics properties do not change between rerenders.
     * Though, we are OK that reference objects passed to those function would change.
     *
     * Doing this we make sure that `useAnalytics` would always give the same reference
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return context;
};

export { useGetAnalyticsContext };
